/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Sales_CampaignInputs */

const en_field_sales_campaign = /** @type {(inputs: Field_Sales_CampaignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales campaign`)
};

/**
* | output |
* | --- |
* | "Sales campaign" |
*
* @param {Field_Sales_CampaignInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_sales_campaign = /** @type {((inputs?: Field_Sales_CampaignInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Sales_CampaignInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_sales_campaign(inputs)
});